// extracted by mini-css-extract-plugin
export default {"release-button":"PageLock_release-button__RvYi+","releaseButton":"PageLock_release-button__RvYi+"};